import React from 'react';
import { Col, Input } from 'antd';
import { I18n } from '@aws-amplify/core';

import type { InputDefaultProps } from '../../../types';
import { FormItem } from '@/components/ui/Inputs/FormItem';

export function ReportName({
	fieldName,
	fontSize = '1rem',
	disabled = false,
	isRequired = false
}: Readonly<InputDefaultProps>) {
	return (
		<Col span={24}>
			<FormItem
				fontSize={fontSize}
				isRequired={isRequired}
				namePath={[fieldName, 'name']}
				title={I18n.get('Report name')}
				errorMessage={I18n.get('Please enter a report name')}
			>
				<Input size="large" placeholder={I18n.get('Report name')} disabled={disabled} />
			</FormItem>
		</Col>
	);
}
